(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-vegas-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vegas-countdown-banner')) {
    class VegasCountdownBanner extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.target);
        this.media = this.querySelector('.vcb__media');
        this.content = this.querySelector('.vcb__content');
        this.els = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]'),
          units: this.querySelector('[data-units]'),
          done: this.querySelector('[data-done]'),
        };

        // The image's size only depends on the page width, so watching it avoids resize loops
        this.resizeObserver = new ResizeObserver(() => this.fitText());
        this.resizeObserver.observe(this.media);
        document.fonts?.ready.then(() => this.fitText());

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.resizeObserver?.disconnect();
      }

      // Shrinks the text block until it is no taller than the visible part of the image
      fitText() {
        const style = this.content.style;
        style.removeProperty('font-size');
        if (window.matchMedia('(max-width: 749px)').matches) return;

        const available = this.media.offsetHeight;
        if (!available) return;

        let size = parseFloat(getComputedStyle(this.content).fontSize);
        for (let i = 0; i < 4; i++) {
          const height = this.content.offsetHeight;
          if (height <= available) break;
          size = Math.max(7, size * (available / height) - 0.25);
          style.fontSize = `${size}px`;
        }
      }

      tick() {
        if (Number.isNaN(this.target)) return;

        const diff = this.target - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          this.els.units.hidden = true;
          this.els.done.hidden = false;
          this.fitText();
          return;
        }

        const pad = (n) => String(n).padStart(2, '0');
        this.els.days.textContent = Math.floor(diff / 86400000);
        this.els.hours.textContent = pad(Math.floor(diff / 3600000) % 24);
        this.els.minutes.textContent = pad(Math.floor(diff / 60000) % 60);
        this.els.seconds.textContent = pad(Math.floor(diff / 1000) % 60);
      }
    }

    customElements.define('vegas-countdown-banner', VegasCountdownBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
